import { render, staticRenderFns } from "./OpenVCView.vue?vue&type=template&id=1c39ee62&scoped=true&"
import script from "./OpenVCView.vue?vue&type=script&lang=js&"
export * from "./OpenVCView.vue?vue&type=script&lang=js&"
import style0 from "./OpenVCView.vue?vue&type=style&index=0&id=1c39ee62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c39ee62",
  null
  
)

export default component.exports